const path = require('path');
const merge = require('lodash.merge');

function getBlazeConfig(rootPath) {
  const paths = new Map();
  const baseBlazeConfig = getBlazeConfigObject(rootPath, rootPath);

  updatePathMap(rootPath, baseBlazeConfig.plugins);

  function addPathToPlugins(configPlugins) {
    const pluginsWithPath = new Map();
    const plugins = configPlugins || {};
    Object.keys(plugins).forEach(pluginName => {
      pluginsWithPath.set(paths.get(pluginName), plugins[pluginName]);
    });
    return pluginsWithPath;
  }

  function updatePathMap(packagePath, plugins) {
    Object.keys(plugins).forEach(pluginName => {
      if (paths.has(pluginName)) return; // don't override path already set
      let pluginPath = pluginName;
      if (!path.isAbsolute(pluginPath)) {
        pluginPath = path.resolve(path.join(packagePath, 'node_modules', pluginPath));
      }
      paths.set(pluginName, pluginPath);
    });
  }

  return (packagePath = null, options = {}) => {
    const { combined = true } = options;
    const configPath = packagePath || process.cwd();

    const projectConfig = getBlazeConfigObject(configPath, packagePath);

    const config = combined ? merge({}, baseBlazeConfig, projectConfig) : projectConfig;
    prepareConfig(config, options);
    config.plugins = addPathToPlugins(config.plugins);
    return config;
  };

  function getBlazeConfigObject(configPath, packagePath) {
    let configObject;
    try {
      // eslint-disable-next-line import/no-dynamic-require, global-require
      const { blaze = { plugins: {} } } = require(`${configPath}/package.json`);
      configObject = { ...blaze };
      updatePathMap(packagePath, configObject.plugins);
    } catch (err) {
      configObject = {};
    }
    return configObject;
  }
}

function prepareConfig(config, options) {
  const { enabledPlugins = [] } = options;
  if (enabledPlugins.length) {
    Object.keys(config.plugins).forEach(pluginName => {
      if (!enabledPlugins.includes(pluginName)) {
        delete config.plugins[pluginName]; // eslint-disable-line
      }
    });
  }
}

module.exports = getBlazeConfig;
